import { createFileRoute } from "@tanstack/react-router";
import { TradeLayout } from "#/features/trade/components/trade-layout";
import { setLastTradeSymbol } from "#/features/trade/stores/last-trade-symbol";

export const Route = createFileRoute("/_app/trade/$symbol")({
	beforeLoad: ({ params }) => {
		setLastTradeSymbol(params.symbol);
	},
	component: RouteComponent,
});

function RouteComponent() {
	return <TradeLayout />;
}
